var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0292969 3.52603C0.0292969 1.73911 1.47788 0.290527 3.26481 0.290527H10.7358C12.5227 0.290527 13.9713 1.73911 13.9713 3.52604V10.9971C13.9713 12.784 12.5227 14.2326 10.7358 14.2326H3.2648C1.47788 14.2326 0.0292969 12.784 0.0292969 10.9971V3.52603ZM9.90558 7.2617C9.90558 8.86586 8.60515 10.1663 7.00099 10.1663C5.39683 10.1663 4.0964 8.86586 4.0964 7.2617C4.0964 5.65754 5.39683 4.35711 7.00099 4.35711C8.60515 4.35711 9.90558 5.65754 9.90558 7.2617ZM11.3577 3.77648C11.839 3.77648 12.2291 3.38635 12.2291 2.9051C12.2291 2.42385 11.839 2.03372 11.3577 2.03372C10.8765 2.03372 10.4864 2.42385 10.4864 2.9051C10.4864 3.38635 10.8765 3.77648 11.3577 3.77648Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.0aa734b7074ec770ca5ae29b81d7626e.svg";
export { ForwardRef as ReactComponent };